import {FrontendUserDataContentType} from '@shared/dynamo_model';

import {createTypedSessionDataStore} from '@shared-frontend/lib/session_store';

const typedDataStore = createTypedSessionDataStore(FrontendUserDataContentType.Onescale);
export const useOnescaleSession = typedDataStore.useData;
